import * as Sentry from "@sentry/react";
import ReactPixel from 'react-facebook-pixel';
import ReactGA from "react-ga4";
import versionInfo from './version.json';

const configs = {
    development: {
        apiUrl: 'https://api.theturbocar.com',
        // apiUrl: 'http://arch.local:8602',
        env: 'development',
        event_ga_id: 'G-1D9DLV7XWM',
        event_meta_id: '1280937800284209',
        stripe_public_key: 'pk_test_51I00oiI4MKN7xq3ZIE9iSffQzioHHKKa8vBtg7msPApbZb4AY33FhKbHIfdKuUhx5b7JUR2EPeGhKKoKhPw9uV3600cG7CyY1t',
        version: versionInfo.commit
    },
    production: {
        apiUrl: 'https://api.theturbocar.com',
        event_ga_id: 'G-1D9DLV7XWM',
        event_meta_id: '1280937800284209',
        // stripe_public_key: 'pk_test_51I00oiI4MKN7xq3ZIE9iSffQzioHHKKa8vBtg7msPApbZb4AY33FhKbHIfdKuUhx5b7JUR2EPeGhKKoKhPw9uV3600cG7CyY1t',
        stripe_public_key: 'pk_live_51QUAjqDnBAnESOIAbh9OAdha9vysBImZ7PBviGRvBb5Asj7Apvm0na3OI89IvfpmRFgbfHPTVJyXNq9pPsIMZ0dX00Fp8Y2iEU',
        env: 'production',
        version: versionInfo.commit
    },
};

type Environment = 'development' | 'production';

const currentEnv: Environment = (process.env.NODE_ENV as Environment) || 'development';

export const initSentry = () => {
    if (currentEnv === 'production') {
        Sentry.init({
            dsn: "https://cbdf7389f7ce45ad84c480703f61b917@sentry.onpy.ru/19",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [/^https:\/\/api.theturbocar.com\/api/],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }
}

export const initEvents = () => {
    if (currentEnv === 'production') {
        ReactPixel.init(config.event_meta_id);
        ReactGA.initialize(config.event_ga_id);
    }
}

export const trackEvent = (event: string, data: any) => {
    console.log(event, data);
    ReactPixel.trackCustom(event, data);
    ReactGA.event({
        category: 'TurboCar',
        action: event,
        label: JSON.stringify(data),
    });
}

export const config = configs[currentEnv];
